import { getEntities, getEntity } from './_utils'
export const getDestinations = getEntities('destinations')
export const getDestination = getEntity('destinations')
